// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'http://localhost:8000' | (string & {});
};

/**
 * AbbreviatedMetricName
 */
export const AbbreviatedMetricName = {
    MILE: 'mile',
    KILOMETER: 'kilometer',
    M: 'm',
    FT: 'ft'
} as const;

/**
 * AbbreviatedMetricName
 */
export type AbbreviatedMetricName = typeof AbbreviatedMetricName[keyof typeof AbbreviatedMetricName];

/**
 * AbsoluteReliabilityImpact
 */
export type AbsoluteReliabilityImpact = {
    /**
     * Type
     */
    type?: 'absolute';
    primary_metric: PrimaryMetric;
    /**
     * Relative Ci In Scope Pct
     */
    relative_ci_in_scope_pct: number;
    /**
     * Relative Outages In Scope Pct
     */
    relative_outages_in_scope_pct: number;
    /**
     * Absolute Outages In Scope
     */
    absolute_outages_in_scope: number;
    /**
     * Absolute Ci In Scope
     */
    absolute_ci_in_scope: number;
    /**
     * Relative Cmi In Scope Pct
     */
    relative_cmi_in_scope_pct: number;
    /**
     * Absolute Cmi In Scope
     */
    absolute_cmi_in_scope: number;
};

/**
 * AggregateResponseList[PlanUnitResponse, PlanResponse]
 */
export type AggregateResponseListPlanUnitResponsePlanResponse = {
    /**
     * Data
     */
    data?: Array<PlanUnitResponse> | null;
    summary?: PlanResponse | null;
};

/**
 * AggregateResponseList[Span, CustomListSummary]
 */
export type AggregateResponseListSpanCustomListSummary = {
    /**
     * Data
     */
    data?: Array<Span> | null;
    summary?: CustomListSummary | null;
};

/**
 * AggregateResponseList[WorkLogResponse, WorkLogSummaryResponse]
 */
export type AggregateResponseListWorkLogResponseWorkLogSummaryResponse = {
    /**
     * Data
     */
    data?: Array<WorkLogResponse> | null;
    summary?: WorkLogSummaryResponse | null;
};

/**
 * AggregateResponseSingle[SearchResults, SearchSummary]
 */
export type AggregateResponseSingleSearchResultsSearchSummary = {
    data?: SearchResults | null;
    summary?: SearchSummary | null;
};

/**
 * AnalysisConfig
 */
export type AnalysisConfigInput = {
    /**
     * Wildfirethreshold
     */
    wildfireThreshold?: number;
    /**
     * Metric
     */
    metric?: 'm' | 'ft';
    clear_span_config?: ClearSpanConfig | null;
};

/**
 * AnalysisConfig
 */
export type AnalysisConfigOutput = {
    /**
     * Wildfirethreshold
     */
    wildfireThreshold: number;
    /**
     * Metric
     */
    metric: 'm' | 'ft';
    clear_span_config: ClearSpanConfig | null;
};

/**
 * BatchRow
 */
export type BatchRow = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Updated At
     */
    updated_at: string;
    /**
     * Delivery Id
     */
    delivery_id?: number | null;
    /**
     * Delivery Identifier
     */
    delivery_identifier?: string | null;
    /**
     * Layer Types
     */
    layer_types?: Array<string>;
};

/**
 * Body_upload_plan_csv_v1_program__program_id__plan_upload_post
 */
export type BodyUploadPlanCsvV1ProgramProgramIdPlanUploadPost = {
    /**
     * Csv File
     */
    csv_file: Blob | File;
};

/**
 * BulkRevokeRequest
 */
export type BulkRevokeRequest = {
    /**
     * Release Ids
     */
    release_ids: Array<string>;
};

/**
 * ClearSpanConfig
 */
export type ClearSpanConfig = {
    /**
     * Vegetation Growth Buffer In Ft
     */
    vegetation_growth_buffer_in_ft?: number | null;
};

/**
 * ClientContextErrorCode
 *
 * Machine-readable marker for 404s raised while resolving the client context from
 * URL params (client/delivery/release). The frontend matches on it (via the generated
 * types) to distinguish a bad link from other not-found errors, so treat it as a
 * public contract.
 */
export const ClientContextErrorCode = { CLIENT_CONTEXT_NOT_FOUND: 'client_context_not_found' } as const;

/**
 * ClientContextErrorCode
 *
 * Machine-readable marker for 404s raised while resolving the client context from
 * URL params (client/delivery/release). The frontend matches on it (via the generated
 * types) to distinguish a bad link from other not-found errors, so treat it as a
 * public contract.
 */
export type ClientContextErrorCode = typeof ClientContextErrorCode[keyof typeof ClientContextErrorCode];

/**
 * ClientContextNotFoundDetail
 */
export type ClientContextNotFoundDetail = {
    code: ClientContextErrorCode;
    /**
     * Message
     */
    message: string;
};

/**
 * ClientContextNotFoundResponse
 */
export type ClientContextNotFoundResponse = {
    detail: ClientContextNotFoundDetail;
};

/**
 * ClientDetail
 */
export type ClientDetail = {
    /**
     * Name
     */
    name: string;
    /**
     * Code
     */
    code: string;
    /**
     * Type
     */
    type: string | null;
    /**
     * Id
     */
    id: number;
    map_config: MapConfig;
    analysis_config: AnalysisConfigOutput | null;
    /**
     * Last Updated
     */
    last_updated: string;
    /**
     * Deliveries
     */
    deliveries: Array<DeliverySummary>;
    /**
     * Datasets
     */
    datasets: Array<DatasetSummary>;
    /**
     * Release Id
     */
    release_id?: string | null;
};

/**
 * ClientSummary
 */
export type ClientSummary = {
    /**
     * Name
     */
    name: string;
    /**
     * Code
     */
    code: string;
    /**
     * Type
     */
    type: string | null;
    /**
     * Id
     */
    id: number;
};

/**
 * ComparisonOp
 */
export const ComparisonOp = { GTE: 'GTE', LTE: 'LTE' } as const;

/**
 * ComparisonOp
 */
export type ComparisonOp = typeof ComparisonOp[keyof typeof ComparisonOp];

/**
 * CostEstimationBasis
 */
export const CostEstimationBasis = { PER_SPAN: 'per_span', PER_DISTANCE: 'per_distance' } as const;

/**
 * CostEstimationBasis
 */
export type CostEstimationBasis = typeof CostEstimationBasis[keyof typeof CostEstimationBasis];

/**
 * CostEstimationConfig
 *
 * Configuration for cost estimation per encroachment risk level.
 *
 * Costs are stored in dollars as integers. The basis determines
 * whether costs are calculated per span or per distance unit (miles or km)
 */
export type CostEstimationConfig = {
    basis: CostEstimationBasis;
    /**
     * High
     */
    high: number;
    /**
     * Medium
     */
    medium: number;
    /**
     * Low
     */
    low: number;
    /**
     * Minor
     */
    minor: number;
    /**
     * None
     */
    none: number;
    /**
     * Unknown
     */
    unknown: number;
};

/**
 * CriticalTreesCountCondition
 */
export type CriticalTreesCountCondition = {
    op: ComparisonOp;
    /**
     * Value
     */
    value: number;
    /**
     * Field
     */
    field?: 'criticalTreesCount';
};

/**
 * CriticalityCategory
 */
export const CriticalityCategory = {
    OUTSIDE_ROW: 'outside_row',
    NONE: 'none',
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    CRITICAL: 'critical'
} as const;

/**
 * CriticalityCategory
 */
export type CriticalityCategory = typeof CriticalityCategory[keyof typeof CriticalityCategory];

/**
 * CustomListBulkAddRequest
 */
export type CustomListBulkAddRequest = {
    /**
     * Addition Filter
     *
     * Base64 encoded JSON string
     */
    addition_filter: string;
};

/**
 * CustomListBulkRemoveRequest
 */
export type CustomListBulkRemoveRequest = {
    /**
     * Spans
     */
    spans?: Array<SpanReference> | null;
    /**
     * Removal Filter
     *
     * Base64 encoded JSON string
     */
    removal_filter?: string | null;
};

/**
 * CustomListCreate
 */
export type CustomListCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string;
    /**
     * Creationfilter
     *
     * Base64 encoded JSON string
     */
    creationFilter?: string | null;
};

/**
 * CustomListMetadata
 */
export type CustomListMetadata = {
    /**
     * Bbox
     */
    bbox?: string | null;
};

/**
 * CustomListSummary
 */
export type CustomListSummary = {
    /**
     * Clientid
     */
    clientId: number;
    /**
     * Total
     */
    total?: number | null;
    /**
     * Modified
     */
    modified?: number | null;
    /**
     * Length
     */
    length?: number | null;
    creationFilter?: GroupAnalysisFilter | null;
    /**
     * Id
     */
    id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Bbox
     */
    bbox?: string | null;
    /**
     * Createdby
     */
    createdBy?: string | null;
    /**
     * Createdat
     */
    createdAt?: string | null;
    /**
     * Updatedat
     */
    updatedAt?: string | null;
    /**
     * Updatedby
     */
    updatedBy?: string | null;
};

/**
 * CustomListUpdate
 */
export type CustomListUpdate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string;
};

/**
 * CustomerCountBySpanPhasing
 */
export type CustomerCountBySpanPhasing = {
    /**
     * Single Phase
     */
    single_phase: number;
    /**
     * Two Phase
     */
    two_phase: number;
    /**
     * Three Phase
     */
    three_phase: number;
};

/**
 * DatasetBase
 */
export type DatasetBase = {
    /**
     * Name
     */
    name: string;
    /**
     * Layer Type
     */
    layer_type: string | null;
    /**
     * Reference
     */
    reference: string | null;
    /**
     * Description
     */
    description: string | null;
};

/**
 * DatasetSummary
 */
export type DatasetSummary = {
    /**
     * Name
     */
    name: string;
    /**
     * Layer Type
     */
    layer_type: string | null;
    /**
     * Reference
     */
    reference: string | null;
    /**
     * Description
     */
    description: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Delivery Id
     */
    delivery_id: number | null;
    /**
     * Scan Id
     */
    scan_id: string | null;
    /**
     * Last Updated
     */
    last_updated: string;
};

/**
 * DeliverySummary
 */
export type DeliverySummary = {
    /**
     * Identifier
     */
    identifier: string;
    /**
     * Description
     */
    description: string;
    /**
     * Id
     */
    id: number;
    /**
     * Created
     */
    created: string;
    /**
     * Last Updated
     */
    last_updated: string;
    /**
     * Published At
     */
    published_at: string | null;
};

/**
 * DemoResetRequest
 */
export type DemoResetRequest = {
    /**
     * Client Code
     */
    client_code: string;
};

/**
 * DemoResetResponse
 *
 * What the reset removed, and what stopped it.
 */
export type DemoResetResponse = {
    /**
     * Client Code
     */
    client_code: string;
    /**
     * Fulcrum Records Deleted
     */
    fulcrum_records_deleted: number;
    /**
     * Fulcrum Projects Deleted
     */
    fulcrum_projects_deleted: number;
    /**
     * Work Logs Deleted
     */
    work_logs_deleted: number;
    /**
     * Plans Deleted
     */
    plans_deleted: number;
    /**
     * Errors
     */
    errors: Array<string>;
};

/**
 * DraftReleaseRequest
 */
export type DraftReleaseRequest = {
    /**
     * Client Code
     */
    client_code: string;
    /**
     * Scan Id
     */
    scan_id: string;
    /**
     * Dry Run
     */
    dry_run?: boolean;
    /**
     * Batch Ids
     */
    batch_ids: Array<string>;
    /**
     * Internal Name
     */
    internal_name?: string | null;
};

/**
 * DraftReleaseRunResponse
 */
export type DraftReleaseRunResponse = {
    /**
     * Run Id
     */
    run_id: string;
    /**
     * Status
     */
    status: string;
    /**
     * Client Code
     */
    client_code?: string | null;
    /**
     * Created By Email
     */
    created_by_email?: string | null;
    /**
     * Internal Name
     */
    internal_name?: string | null;
    /**
     * Started At
     */
    started_at?: number | null;
    /**
     * Url
     */
    url: string;
};

/**
 * EncroachmentRatingCondition
 */
export type EncroachmentRatingCondition = {
    /**
     * Op
     */
    op: 'IN' | 'NOT_IN';
    /**
     * Values
     */
    values: Array<EncroachmentRiskRating>;
    /**
     * Field
     */
    field?: 'encroachmentRating';
};

/**
 * EncroachmentRiskRating
 */
export const EncroachmentRiskRating = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5
} as const;

/**
 * EncroachmentRiskRating
 */
export type EncroachmentRiskRating = typeof EncroachmentRiskRating[keyof typeof EncroachmentRiskRating];

/**
 * ExportFormat
 */
export const ExportFormat = {
    JSON: 'json',
    GEOPACKAGE: 'geopackage',
    PARQUET: 'parquet',
    CSV: 'csv'
} as const;

/**
 * ExportFormat
 */
export type ExportFormat = typeof ExportFormat[keyof typeof ExportFormat];

/**
 * FilterGroup
 */
export type FilterGroup = {
    /**
     * Operator
     */
    operator: 'AND' | 'OR';
    /**
     * Conditions
     */
    conditions: Array<({
        field: 'network';
    } & NetworkCondition) | ({
        field: 'phasingType';
    } & PhasingTypeCondition) | ({
        field: 'voltageInKv';
    } & VoltageInKvCondition) | ({
        field: 'encroachmentRating';
    } & EncroachmentRatingCondition) | ({
        field: 'priorityRating';
    } & PriorityRatingCondition) | ({
        field: 'wildfireRating';
    } & WildfireRatingCondition) | ({
        field: 'wildfirePriorityRating';
    } & WildfirePriorityRatingCondition) | ({
        field: 'hazardTreesCount';
    } & HazardTreesCountCondition) | ({
        field: 'strikeTreesCount';
    } & StrikeTreesCountCondition) | ({
        field: 'criticalTreesCount';
    } & CriticalTreesCountCondition) | ({
        field: 'hasOverhang';
    } & HasOverhangCondition) | ({
        field: 'species';
    } & SpeciesCondition) | ({
        field: 'workStatus';
    } & WorkStatusCondition) | ({
        field: 'fuelHazardRating';
    } & FuelHazardRatingCondition) | FilterGroup>;
};

/**
 * FuelCategories
 */
export type FuelCategories = {
    /**
     * Grass
     */
    grass?: number;
    /**
     * Shrub
     */
    shrub?: number;
    /**
     * Timber Litter
     */
    timber_litter?: number;
    /**
     * Slash Blowdown
     */
    slash_blowdown?: number;
    /**
     * Non Burnable
     */
    non_burnable?: number;
};

/**
 * FuelCategory
 */
export const FuelCategory = {
    GRASS: 'grass',
    SHRUB: 'shrub',
    TIMBER_LITTER: 'timber_litter',
    SLASH_BLOWDOWN: 'slash_blowdown',
    NON_BURNABLE: 'non_burnable'
} as const;

/**
 * FuelCategory
 */
export type FuelCategory = typeof FuelCategory[keyof typeof FuelCategory];

/**
 * FuelCategoryBucket
 *
 * Non-overlapping share-of-span buckets used by the fuel distribution filter.
 *
 * Each bucket is (low, high], and a value on a boundary matches its UI label (5% falls into the "0-5%" bucket).
 */
export const FuelCategoryBucket = {
    LESS_THAN_5: 'less_than_5',
    '6_TO_25': '6_to_25',
    '26_TO_50': '26_to_50',
    '51_TO_75': '51_to_75',
    MORE_THAN_75: 'more_than_75'
} as const;

/**
 * FuelCategoryBucket
 *
 * Non-overlapping share-of-span buckets used by the fuel distribution filter.
 *
 * Each bucket is (low, high], and a value on a boundary matches its UI label (5% falls into the "0-5%" bucket).
 */
export type FuelCategoryBucket = typeof FuelCategoryBucket[keyof typeof FuelCategoryBucket];

/**
 * FuelCategoryThreshold
 */
export type FuelCategoryThreshold = {
    category: FuelCategory;
    bucket: FuelCategoryBucket;
};

/**
 * FuelHazardRating
 */
export const FuelHazardRating = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5
} as const;

/**
 * FuelHazardRating
 */
export type FuelHazardRating = typeof FuelHazardRating[keyof typeof FuelHazardRating];

/**
 * FuelHazardRatingCondition
 *
 * Fuel hazard rating (1-5), normalized against the release in context.
 *
 * The fuel_hazard_rating CTE bands each span's fuel score against the min/max of the
 * single release the context resolves, so a rating is only comparable within
 * that release. Spans with no fuel row read as rating 1 ('none'), matching the
 * rating expression's NULL-score band — on a client without fuel data every
 * span rates 1, so a saved filter selects all or nothing rather than erroring.
 */
export type FuelHazardRatingCondition = {
    /**
     * Op
     */
    op: 'IN' | 'NOT_IN';
    /**
     * Values
     */
    values: Array<FuelHazardRating>;
    /**
     * Field
     */
    field?: 'fuelHazardRating';
};

/**
 * FulcrumSyncPhase
 */
export const FulcrumSyncPhase = {
    PREPARING: 'preparing',
    PUSHING: 'pushing',
    PULLING: 'pulling',
    SAVING: 'saving'
} as const;

/**
 * FulcrumSyncPhase
 */
export type FulcrumSyncPhase = typeof FulcrumSyncPhase[keyof typeof FulcrumSyncPhase];

/**
 * FulcrumSyncStatus
 */
export type FulcrumSyncStatus = {
    /**
     * Id
     */
    id: string;
    /**
     * Plan Id
     */
    plan_id: string;
    status: TaskStatus;
    phase: FulcrumSyncPhase | null;
    /**
     * Started At
     */
    started_at: string;
    /**
     * Finished At
     */
    finished_at: string | null;
};

/**
 * GroupAnalysisData
 */
export type GroupAnalysisData = {
    /**
     * Group
     */
    group?: string | null;
    /**
     * Networkgroupid
     */
    networkGroupId: string;
    /**
     * Displayname
     */
    displayName?: string | null;
    /**
     * Length
     */
    length: number;
    metric: MetricName;
    /**
     * Criticaltreescount
     */
    criticalTreesCount?: number | null;
    /**
     * Striketreescount
     */
    strikeTreesCount?: number | null;
    /**
     * Bbox
     */
    bbox: string;
    /**
     * Totalencscore
     */
    totalEncScore?: number | null;
    /**
     * Totalpriorityscore
     */
    totalPriorityScore?: number | null;
    /**
     * Totalwildfirepriorityscore
     */
    totalWildfirePriorityScore?: number | null;
    /**
     * Totalspans
     */
    totalSpans?: number | null;
    /**
     * Clearspancount
     */
    clearSpanCount?: number | null;
    /**
     * Clearpercentage
     */
    clearPercentage?: number | null;
    /**
     * Hazardtreescount
     */
    hazardTreesCount?: number | null;
    /**
     * Level2
     */
    level2?: string | null;
    /**
     * Phasingtype
     */
    phasingType?: string | null;
    /**
     * Voltageinkv
     */
    voltageInKv?: number | null;
    workStatus?: WorkLogStatus | null;
    /**
     * Encrating
     */
    encRating?: number | null;
    /**
     * Priorityrating
     */
    priorityRating?: number | null;
    /**
     * Wildfirepriorityrating
     */
    wildfirePriorityRating?: number | null;
    /**
     * Tagslist
     */
    tagsList?: Array<GroupAnalysisTag> | null;
    /**
     * Network
     */
    network?: number | null;
    /**
     * Lists
     */
    lists?: Array<CustomListSummary> | null;
    /**
     * Wildfirerisk
     */
    wildfireRisk?: number | null;
    /**
     * Wildfireburnability
     */
    wildfireBurnability?: number | null;
    /**
     * Wildfireexposure
     */
    wildfireExposure?: number | null;
    /**
     * Fuelhazardrating
     */
    fuelHazardRating?: number | null;
    /**
     * Fuelhazardscore
     */
    fuelHazardScore?: number | null;
};

/**
 * GroupAnalysisFilter
 */
export type GroupAnalysisFilter = {
    /**
     * Network
     */
    network?: Array<number> | null;
    /**
     * Groups
     */
    groups?: {
        [key: string]: Array<string | null>;
    } | null;
    /**
     * Phasingtype
     */
    phasingType?: Array<string> | null;
    /**
     * Voltageinkv
     */
    voltageInKv?: Array<number> | null;
    /**
     * Priorityratings
     */
    priorityRatings?: Array<number> | null;
    /**
     * Wildfirepriorityratings
     */
    wildfirePriorityRatings?: Array<number> | null;
    /**
     * Encroachmentratings
     */
    encroachmentRatings?: Array<number> | null;
    /**
     * Hashazardtrees
     */
    hasHazardTrees?: boolean | null;
    /**
     * Hascriticaltrees
     */
    hasCriticalTrees?: boolean | null;
    /**
     * Hasstriketrees
     */
    hasStrikeTrees?: boolean | null;
    /**
     * Hasoverhang
     */
    hasOverhang?: boolean | null;
    /**
     * Species
     */
    species?: Array<number> | null;
    /**
     * Wildfireratings
     */
    wildfireRatings?: Array<number> | null;
    /**
     * Redflagwarnings
     */
    redFlagWarnings?: Array<string> | null;
    /**
     * Workstatus
     */
    workStatus?: Array<string> | null;
    /**
     * Tags
     */
    tags?: Array<number> | null;
    /**
     * Updatedatyears
     */
    updatedAtYears?: Array<string> | null;
    /**
     * Fuelhazardratings
     */
    fuelHazardRatings?: Array<number> | null;
    /**
     * Fuelcategorythresholds
     */
    fuelCategoryThresholds?: Array<FuelCategoryThreshold> | null;
};

/**
 * GroupAnalysisSpanData
 */
export type GroupAnalysisSpanData = {
    /**
     * Level3
     */
    level3: string;
    /**
     * Level2
     */
    level2: string | null;
    /**
     * Group
     */
    group: string;
    /**
     * Networkgroupid
     */
    networkGroupId: number;
    /**
     * Displayname
     */
    displayName: string | null;
    /**
     * Network
     */
    network: number | null;
    /**
     * Phasingtype
     */
    phasingType: string | null;
    /**
     * Voltageinkv
     */
    voltageInKv: number | null;
    /**
     * Bufferinft
     */
    bufferInFt: number | null;
    /**
     * Length
     */
    length: number | null;
    metric: AbbreviatedMetricName;
    /**
     * Encrating
     */
    encRating?: number | null;
    /**
     * Encscore
     */
    encScore?: number | null;
    /**
     * Priorityrating
     */
    priorityRating: number;
    /**
     * Wildfirepriorityrating
     */
    wildfirePriorityRating: number;
    /**
     * Totalwildfirepriorityscore
     */
    totalWildfirePriorityScore: number;
    /**
     * Mindistspaninft
     */
    minDistSpanInFt: number | null;
    /**
     * Closesttree
     */
    closestTree?: string | null;
    /**
     * Treecoverpct
     */
    treeCoverPct: number | null;
    /**
     * Hasoverhang
     */
    hasOverhang: boolean;
    /**
     * Hazardtreescount
     */
    hazardTreesCount: number | null;
    /**
     * Striketreescount
     */
    strikeTreesCount: number | null;
    /**
     * Decliningtreescount
     */
    decliningTreesCount: number | null;
    /**
     * Criticaltreescount
     */
    criticalTreesCount: number | null;
    /**
     * Wildfirerating
     */
    wildfireRating?: number | null;
    fuelCategories?: FuelCategories | null;
    /**
     * Fuelhazardrating
     */
    fuelHazardRating?: number | null;
    /**
     * Fuelhazardscore
     */
    fuelHazardScore?: number | null;
    /**
     * Annualburnprobability
     */
    annualBurnProbability?: number | null;
    workStatus: WorkLogStatus | null;
    workTypeAnalysis?: WorkTypeAnalysis | null;
    /**
     * Lists
     */
    lists: Array<SpanListReference>;
    [key: string]: unknown;
};

/**
 * GroupAnalysisTag
 */
export type GroupAnalysisTag = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string;
};

/**
 * GroupAnalysisType
 */
export const GroupAnalysisType = {
    ENCROACHMENT: 'encroachment',
    PRIORITY: 'priority',
    WORKLOAD_ANALYSIS: 'workloadAnalysis',
    FALL_IN: 'fallIn',
    CLEAR: 'clear',
    WILDFIRE_PRIORITY: 'wildfirePriority'
} as const;

/**
 * GroupAnalysisType
 */
export type GroupAnalysisType = typeof GroupAnalysisType[keyof typeof GroupAnalysisType];

/**
 * GroupSummary
 */
export type GroupSummary = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Totalencscore
     */
    totalEncScore?: number | null;
    /**
     * Totalpriorityscore
     */
    totalPriorityScore?: number | null;
    /**
     * Totalwildfirepriorityscore
     */
    totalWildfirePriorityScore?: number | null;
    /**
     * Criticaltreescount
     */
    criticalTreesCount?: number | null;
    /**
     * Clearspancount
     */
    clearSpanCount?: number | null;
    /**
     * Totalspans
     */
    totalSpans?: number | null;
    /**
     * Clearpercentage
     */
    clearPercentage?: number | null;
    /**
     * Hazardtreescount
     */
    hazardTreesCount?: number | null;
    /**
     * Wildfirerisk
     */
    wildfireRisk?: number | null;
    /**
     * Wildfireburnability
     */
    wildfireBurnability?: number | null;
    /**
     * Wildfireexposure
     */
    wildfireExposure?: number | null;
    fuelCategories?: FuelCategories | null;
};

/**
 * HasOverhangCondition
 */
export type HasOverhangCondition = {
    /**
     * Value
     */
    value: boolean;
    /**
     * Field
     */
    field?: 'hasOverhang';
};

/**
 * HazardTreesCountCondition
 */
export type HazardTreesCountCondition = {
    op: ComparisonOp;
    /**
     * Value
     */
    value: number;
    /**
     * Field
     */
    field?: 'hazardTreesCount';
};

/**
 * LayerType
 */
export const LayerType = {
    BASE: 'base',
    POLES: 'poles',
    LINES: 'lines',
    SEGMENTATION: 'segmentation',
    TREE_TYPE: 'tree_type',
    TREES: 'trees',
    SCAN: 'scan',
    SPANS: 'spans',
    ENCROACHMENT: 'encroachment',
    OVERHANG: 'overhang',
    TREE_SPECIES: 'tree_species',
    WILDFIRE_RISK: 'wildfire_risk',
    DISTANCE_BUCKET: 'distance_bucket',
    SATELLITE_METADATA: 'satellite_metadata',
    CRITICAL_TREES: 'critical_trees',
    WORKTYPE_ANALYSIS: 'worktype_analysis',
    WILDFIRE_PRIORITY_LEVEL: 'wildfire_priority_level',
    FUEL_DETECTION_MODEL_ANALYSIS: 'fuel_detection_model_analysis',
    FUEL_HAZARD: 'fuel_hazard',
    WILDFIRE_CONSEQUENCE: 'wildfire_consequence',
    BURNABILITY_INDEX: 'burnability_index',
    ENCROACHMENT_ANALYSIS: 'encroachment_analysis',
    ENCROACHMENT_RISK: 'encroachment_risk',
    WILDFIRE_RATING: 'wildfire_rating',
    WORKTYPE: 'worktype'
} as const;

/**
 * LayerType
 */
export type LayerType = typeof LayerType[keyof typeof LayerType];

/**
 * MapConfig
 */
export type MapConfig = {
    /**
     * Longitude
     */
    longitude: number;
    /**
     * Latitude
     */
    latitude: number;
    /**
     * Zoom
     */
    zoom: number;
    /**
     * Bbox
     */
    bbox?: Array<number> | null;
};

/**
 * MetricName
 */
export const MetricName = {
    MILE: 'mile',
    KILOMETER: 'kilometer',
    METER: 'meter',
    FEET: 'feet'
} as const;

/**
 * MetricName
 */
export type MetricName = typeof MetricName[keyof typeof MetricName];

/**
 * Network
 */
export const Network = { 1: 1, 2: 2 } as const;

/**
 * Network
 */
export type Network = typeof Network[keyof typeof Network];

/**
 * NetworkCondition
 */
export type NetworkCondition = {
    /**
     * Op
     */
    op: 'IN' | 'NOT_IN';
    /**
     * Values
     */
    values: Array<Network>;
    /**
     * Field
     */
    field?: 'network';
};

/**
 * NetworkGroupData
 */
export type NetworkGroupData = {
    /**
     * Id
     */
    id: number | string;
    /**
     * Displayname
     */
    displayName: string;
    /**
     * Name
     */
    name: string;
    /**
     * Singularinline
     */
    singularInline?: string | null;
    /**
     * Singulartitle
     */
    singularTitle?: string | null;
    /**
     * Pluralinline
     */
    pluralInline?: string | null;
    /**
     * Pluraltitle
     */
    pluralTitle?: string | null;
    /**
     * Category
     */
    category?: string | null;
    /**
     * Values
     */
    values?: Array<string> | null;
    /**
     * Searchable
     */
    searchable?: boolean | null;
    /**
     * Types
     */
    types?: Array<NetworkGroupType> | null;
};

/**
 * NetworkGroupType
 */
export const NetworkGroupType = {
    PLANNING: 'planning',
    REPORTING: 'reporting',
    CYCLE_PLAN: 'cycle_plan'
} as const;

/**
 * NetworkGroupType
 */
export type NetworkGroupType = typeof NetworkGroupType[keyof typeof NetworkGroupType];

/**
 * NetworkGroupValuesPage
 */
export type NetworkGroupValuesPage = {
    /**
     * Values
     */
    values: Array<string>;
    /**
     * Nextcursor
     */
    nextCursor?: string | null;
};

/**
 * NetworkRiskAggregateBreakdownUnit
 *
 * Flexible breakdown unit for aggregated network risk data (priorities, encroachment, etc).
 */
export type NetworkRiskAggregateBreakdownUnit = {
    /**
     * Riskrating
     *
     * Risk rating value (0=unknown, 1=none, 2=minor, 3=low, 4=medium, 5=high for encroachment; numerical value for priority)
     */
    riskRating: number;
    /**
     * Type of risk metric (priority, encroachment, etc)
     */
    riskMetric: RiskMetricType;
    /**
     * Unit of measurement (spans, miles, etc)
     */
    unit: RiskUnit;
    /**
     * Unitcount
     *
     * Amount/count in the specified unit
     */
    unitCount: number;
};

/**
 * PRIORITY_RATING
 */
export const PriorityRating = {
    999: 999,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5
} as const;

/**
 * PRIORITY_RATING
 */
export type PriorityRating = typeof PriorityRating[keyof typeof PriorityRating];

/**
 * PhasingType
 */
export const PhasingType = {
    SINGLE_PHASE: 'single-phase',
    TWO_PHASE: 'two-phase',
    THREE_PHASE: 'three-phase'
} as const;

/**
 * PhasingType
 */
export type PhasingType = typeof PhasingType[keyof typeof PhasingType];

/**
 * PhasingTypeCondition
 */
export type PhasingTypeCondition = {
    /**
     * Op
     */
    op: 'IN' | 'NOT_IN';
    /**
     * Values
     */
    values: Array<PhasingType>;
    /**
     * Field
     */
    field?: 'phasingType';
};

/**
 * PlanCreateRequest
 */
export type PlanCreateRequest = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    scope_filter?: ScopeRules | null;
};

/**
 * PlanProgress
 */
export type PlanProgress = {
    /**
     * Completed Spans
     */
    completed_spans: number;
    /**
     * Total Spans
     */
    total_spans: number;
};

/**
 * PlanResponse
 *
 * Response model for the DB Plan table model with a required id.
 */
export type PlanResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Scope Filter
     */
    scope_filter?: {
        [key: string]: unknown;
    } | null;
    status: PlanStatus;
    /**
     * Program Id
     */
    program_id: number;
    /**
     * Client Id
     */
    client_id: number;
    /**
     * Release Id
     */
    release_id?: string | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Updated At
     */
    updated_at: string;
};

/**
 * PlanStatsResponse
 */
export type PlanStatsResponse = {
    reliability_risk?: ReliabilityRisk | null;
    /**
     * Reliability Impact
     */
    reliability_impact?: ({
        type: 'relative';
    } & RelativeReliabilityImpact) | ({
        type: 'absolute';
    } & AbsoluteReliabilityImpact) | null;
    wildfire_impact?: WildfireImpact | null;
    workload: Workload;
    /**
     * Cost Estimated
     */
    cost_estimated?: number | null;
};

/**
 * PlanStatus
 */
export const PlanStatus = {
    DRAFT: 'draft',
    ACTIVE: 'active',
    ARCHIVED: 'archived'
} as const;

/**
 * PlanStatus
 */
export type PlanStatus = typeof PlanStatus[keyof typeof PlanStatus];

/**
 * PlanUnitReliabilityImpact
 */
export type PlanUnitReliabilityImpact = {
    /**
     * Primary Metric
     */
    primary_metric: PrimaryMetric | 'relative_ci_pct';
    /**
     * Value
     */
    value: number;
};

/**
 * PlanUnitResponse
 */
export type PlanUnitResponse = {
    /**
     * Referencename
     */
    referenceName: string;
    /**
     * Totalmiles
     */
    totalMiles: number;
    /**
     * Spancount
     */
    spanCount: number;
    /**
     * Prioritiesaggregate
     *
     * Aggregation of span mileage by priority
     */
    prioritiesAggregate: Array<NetworkRiskAggregateBreakdownUnit>;
    /**
     * Totalpriorityscore
     *
     * Total priority score as a simple summation of all span scores
     */
    totalPriorityScore: number;
    /**
     * Reliability impact for the unit's full (unscoped) network; null when the impact-metrics flag is off
     */
    totalReliabilityImpact: PlanUnitReliabilityImpact | null;
    /**
     * Reliability impact for the unit's in-scope spans; null when the impact-metrics flag is off
     */
    scopedReliabilityImpact: PlanUnitReliabilityImpact | null;
    /**
     * Scopedmiles
     *
     * Miles of spans matching the plan scope filter
     */
    scopedMiles: number | null;
    /**
     * Totalwildfirerisk
     *
     * Wildfire risk for the unit's full network; null unless flag-wildfire is 'all'
     */
    totalWildfireRisk: number | null;
    /**
     * Scopedwildfirerisk
     *
     * Wildfire risk for the unit's in-scope spans; null unless flag-wildfire is 'all'
     */
    scopedWildfireRisk: number | null;
    /**
     * Scopedencroachmentbreakdown
     *
     * Breakdown of spans and miles by encroachment rating
     */
    scopedEncroachmentBreakdown: Array<ScopedEncroachmentBreakdownUnit>;
    /**
     * Scopedencroachmentaggregate
     *
     * Breakdown of spans or miles by encroachment rating
     */
    scopedEncroachmentAggregate: Array<NetworkRiskAggregateBreakdownUnit>;
    /**
     * Id
     *
     * Plan unit ID
     */
    id: number | null;
    /**
     * Lasttrimdate
     *
     * Last trim date (ISO 8601 string)
     */
    lastTrimDate: string | null;
    /**
     * Nexttrimdate
     *
     * Next trim date (ISO 8601 string)
     */
    nextTrimDate: string | null;
    /**
     * Targetstart
     *
     * Target start date (ISO 8601 string)
     */
    targetStart: string | null;
    /**
     * Workstarted
     *
     * Work start date (ISO 8601 string)
     */
    workStarted: string | null;
    /**
     * Workended
     *
     * Work end date (ISO 8601 string)
     */
    workEnded: string | null;
    /**
     * Notes
     *
     * Additional notes
     */
    notes: string | null;
    /**
     * Current plan unit status
     */
    status: PlanUnitStatus | null;
    /**
     * Contractor
     *
     * Contractor associated with this plan unit
     */
    contractor: string | null;
    /**
     * Costestimation
     *
     * Estimated cost for this plan unit in dollars
     */
    costEstimation: number | null;
};

/**
 * PlanUnitStatus
 */
export const PlanUnitStatus = {
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    TODO: 'todo',
    TO_AUDIT: 'to_audit'
} as const;

/**
 * PlanUnitStatus
 */
export type PlanUnitStatus = typeof PlanUnitStatus[keyof typeof PlanUnitStatus];

/**
 * PlanUpdateRequest
 */
export type PlanUpdateRequest = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    scope_filter?: ScopeRules | null;
    old_values?: Plan | null;
};

/**
 * PlanUploadResponse
 */
export type PlanUploadResponse = {
    /**
     * Plan Id
     */
    plan_id: string;
    /**
     * Planning Unit Scenarios Created
     */
    planning_unit_scenarios_created: number;
};

/**
 * PlanWithProgress
 */
export type PlanWithProgress = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Scope Filter
     */
    scope_filter?: {
        [key: string]: unknown;
    } | null;
    status: PlanStatus;
    /**
     * Program Id
     */
    program_id: number;
    /**
     * Client Id
     */
    client_id: number;
    /**
     * Release Id
     */
    release_id?: string | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Updated At
     */
    updated_at: string;
    in_scope_stats: PlanStatsResponse;
    progress: PlanProgress;
};

/**
 * PlanWithStats
 */
export type PlanWithStats = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Scope Filter
     */
    scope_filter?: {
        [key: string]: unknown;
    } | null;
    status: PlanStatus;
    /**
     * Program Id
     */
    program_id: number;
    /**
     * Client Id
     */
    client_id: number;
    /**
     * Release Id
     */
    release_id?: string | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Updated At
     */
    updated_at: string;
    in_scope_stats: PlanStatsResponse;
};

/**
 * PlanningUnitScenarioUpdateRequest
 */
export type PlanningUnitScenarioUpdateRequest = {
    /**
     * Nexttrimdate
     */
    nextTrimDate: string | null;
    oldValues?: PlanningUnitScenario | null;
};

/**
 * PlanningUnitUpdateRequest
 */
export type PlanningUnitUpdateRequest = {
    /**
     * Lasttrimdate
     */
    lastTrimDate?: string | null;
    /**
     * Status
     */
    status?: string | null;
    /**
     * Contractor
     */
    contractor?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
    /**
     * Targetstart
     */
    targetStart?: string | null;
    /**
     * Workstarted
     */
    workStarted?: string | null;
    /**
     * Workended
     */
    workEnded?: string | null;
    oldValues?: PlanningUnit | null;
};

/**
 * PrimaryMetric
 */
export const PrimaryMetric = {
    ABSOLUTE_OUTAGES: 'absolute_outages',
    ABSOLUTE_CI: 'absolute_ci',
    ABSOLUTE_CMI: 'absolute_cmi'
} as const;

/**
 * PrimaryMetric
 */
export type PrimaryMetric = typeof PrimaryMetric[keyof typeof PrimaryMetric];

/**
 * PriorityRatingCondition
 */
export type PriorityRatingCondition = {
    /**
     * Op
     */
    op: 'IN' | 'NOT_IN';
    /**
     * Values
     */
    values: Array<PriorityRating>;
    /**
     * Field
     */
    field?: 'priorityRating';
};

/**
 * ProgramCreateRequest
 */
export type ProgramCreateRequest = {
    /**
     * Name
     */
    name: string;
    type: ProgramType;
    /**
     * Description
     */
    description?: string | null;
    cost_estimation_config?: CostEstimationConfig | null;
};

/**
 * ProgramListItem
 */
export type ProgramListItem = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
    type: ProgramType;
    /**
     * Description
     */
    description?: string | null;
    cost_estimation_config?: CostEstimationConfig | null;
    active_scenario_stats?: PlanStatsResponse | null;
    /**
     * Plans
     */
    plans?: Array<PlanResponse>;
};

/**
 * ProgramType
 */
export const ProgramType = {
    CYCLE: 'cycle',
    HOTSPOT: 'hotspot',
    PROJECT: 'project'
} as const;

/**
 * ProgramType
 */
export type ProgramType = typeof ProgramType[keyof typeof ProgramType];

/**
 * ProgramUpdateRequest
 */
export type ProgramUpdateRequest = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    cost_estimation_config?: CostEstimationConfig | null;
};

/**
 * PublishRequest
 */
export type PublishRequest = {
    /**
     * Display Name
     */
    display_name?: string | null;
    /**
     * Release Id To Replace
     */
    release_id_to_replace?: string | null;
};

/**
 * RasterLayerSource
 *
 * A mosaic served by the tiler, addressed by the release it is requested through.
 */
export type RasterLayerSource = {
    /**
     * Kind
     */
    kind: 'raster';
    /**
     * Layer Type
     */
    layer_type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Release Id
     */
    release_id: string;
};

/**
 * RelativeReliabilityImpact
 */
export type RelativeReliabilityImpact = {
    /**
     * Type
     */
    type?: 'relative';
    /**
     * Relative Ci In Scope Pct
     */
    relative_ci_in_scope_pct: number;
};

/**
 * ReleaseDetail
 */
export type ReleaseDetail = {
    /**
     * Id
     */
    id: string;
    /**
     * Client Code
     */
    client_code: string;
    /**
     * Client Name
     */
    client_name: string;
    effective_status: ReleaseStatusEffective;
    /**
     * Display Name
     */
    display_name?: string | null;
    /**
     * Internal Name
     */
    internal_name?: string | null;
    /**
     * Scan Id
     */
    scan_id?: string | null;
    /**
     * Scan Label
     */
    scan_label?: string | null;
    /**
     * Scan Started At
     */
    scan_started_at?: string | null;
    /**
     * Created By Email
     */
    created_by_email?: string | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Updated At
     */
    updated_at: string;
    /**
     * Batches
     */
    batches: Array<BatchRow>;
    /**
     * Is Latest
     */
    is_latest: boolean;
    /**
     * Published By
     */
    published_by?: string | null;
    /**
     * Published At
     */
    published_at?: string | null;
    /**
     * Revoked By
     */
    revoked_by?: string | null;
    /**
     * Revoked At
     */
    revoked_at?: string | null;
};

/**
 * ReleasePage
 */
export type ReleasePage = {
    /**
     * Items
     */
    items: Array<ReleaseRow>;
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number;
    /**
     * Limit
     */
    limit: number;
    /**
     * Newest Draft Release Id
     */
    newest_draft_release_id?: string | null;
};

/**
 * ReleaseRename
 */
export type ReleaseRename = {
    /**
     * Display Name
     */
    display_name?: string | null;
};

/**
 * ReleaseRow
 */
export type ReleaseRow = {
    /**
     * Id
     */
    id: string;
    /**
     * Client Code
     */
    client_code: string;
    /**
     * Client Name
     */
    client_name: string;
    effective_status: ReleaseStatusEffective;
    /**
     * Display Name
     */
    display_name?: string | null;
    /**
     * Internal Name
     */
    internal_name?: string | null;
    /**
     * Scan Id
     */
    scan_id?: string | null;
    /**
     * Scan Label
     */
    scan_label?: string | null;
    /**
     * Scan Started At
     */
    scan_started_at?: string | null;
    /**
     * Created By Email
     */
    created_by_email?: string | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Updated At
     */
    updated_at: string;
};

/**
 * ReleaseStatusEffective
 */
export const ReleaseStatusEffective = {
    DRAFT: 'draft',
    PUBLISHED: 'published',
    REVOKED: 'revoked',
    ARCHIVED: 'archived',
    COMBINED: 'combined'
} as const;

/**
 * ReleaseStatusEffective
 */
export type ReleaseStatusEffective = typeof ReleaseStatusEffective[keyof typeof ReleaseStatusEffective];

/**
 * ReliabilityMetricsConfig
 */
export type ReliabilityMetricsConfig = {
    /**
     * Id
     */
    id?: string;
    /**
     * Created At
     */
    created_at?: string;
    /**
     * Client Id
     */
    client_id: number;
    /**
     * Version
     */
    version: number;
    primary_metric: PrimaryMetric;
    /**
     * Data Source Name
     */
    data_source_name: string;
    /**
     * Data Source Period Start
     */
    data_source_period_start: string;
    /**
     * Data Source Period End
     */
    data_source_period_end: string;
    /**
     * Total Overhead Dist Line Miles
     */
    total_overhead_dist_line_miles: number;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Total Outages
     */
    total_outages: number;
    /**
     * Total Enc Related Outages
     */
    total_enc_related_outages: number;
    /**
     * Total Fallin Related Outages
     */
    total_fallin_related_outages: number;
    /**
     * Total Ci Instances
     */
    total_ci_instances: number;
    /**
     * Total Enc Related Ci Instances
     */
    total_enc_related_ci_instances: number;
    /**
     * Total Cmi
     */
    total_cmi: number;
    /**
     * Total Enc Related Cmi
     */
    total_enc_related_cmi: number;
    /**
     * Total Fallin Related Cmi
     */
    total_fallin_related_cmi: number;
    customer_count_by_span_phasing?: CustomerCountBySpanPhasing | null;
    /**
     * Created By User Id
     */
    created_by_user_id: string;
};

/**
 * ReliabilityMetricsConfigCreate
 */
export type ReliabilityMetricsConfigCreate = {
    primary_metric: PrimaryMetric;
    /**
     * Data Source Name
     */
    data_source_name: string;
    /**
     * Data Source Period Start
     */
    data_source_period_start: string;
    /**
     * Data Source Period End
     */
    data_source_period_end: string;
    /**
     * Total Overhead Dist Line Miles
     */
    total_overhead_dist_line_miles: number;
    /**
     * Total Enc Related Outages
     */
    total_enc_related_outages: number;
    /**
     * Total Fallin Related Outages
     */
    total_fallin_related_outages: number;
    /**
     * Total Ci Instances
     */
    total_ci_instances: number;
    /**
     * Total Enc Related Cmi
     */
    total_enc_related_cmi: number;
    /**
     * Total Fallin Related Cmi
     */
    total_fallin_related_cmi: number;
    /**
     * Description
     */
    description?: string | null;
    customer_count_by_span_phasing?: CustomerCountBySpanPhasing | null;
};

/**
 * ReliabilityRisk
 */
export type ReliabilityRisk = {
    /**
     * Risk Total
     */
    risk_total: number;
    /**
     * Risk Addressed
     */
    risk_addressed: number;
    /**
     * Risk Addressed Pct
     */
    risk_addressed_pct: number;
};

/**
 * RiskMetricType
 *
 * Enum for types of risk metrics.
 */
export const RiskMetricType = { PRIORITY: 'priority', ENC: 'enc' } as const;

/**
 * RiskMetricType
 *
 * Enum for types of risk metrics.
 */
export type RiskMetricType = typeof RiskMetricType[keyof typeof RiskMetricType];

/**
 * RiskUnit
 *
 * Enum for units of measurement in risk breakdowns.
 */
export const RiskUnit = {
    SPANS: 'spans',
    MILES: 'miles',
    KILOMETERS: 'kilometers'
} as const;

/**
 * RiskUnit
 *
 * Enum for units of measurement in risk breakdowns.
 */
export type RiskUnit = typeof RiskUnit[keyof typeof RiskUnit];

/**
 * ScanOption
 */
export type ScanOption = {
    /**
     * Scan Id
     */
    scan_id: string;
    /**
     * Label
     */
    label: string | null;
};

/**
 * ScopeBatch
 */
export type ScopeBatch = {
    /**
     * Batch Id
     */
    batch_id: string;
    /**
     * Scope
     */
    scope: string;
    /**
     * Kind
     */
    kind: 'delivery' | 'scan_wide';
    layer_type: LayerType;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Is Published
     */
    is_published: boolean;
};

/**
 * ScopeOption
 */
export type ScopeOption = {
    /**
     * Value
     */
    value: string;
    /**
     * Label
     */
    label: string;
    /**
     * Kind
     */
    kind: 'delivery' | 'scan_wide';
};

/**
 * ScopePreviewRequest
 */
export type ScopePreviewRequest = {
    scope_rules: ScopeRules;
};

/**
 * ScopePreviewResponse
 */
export type ScopePreviewResponse = {
    /**
     * Span Count
     */
    span_count: number;
};

/**
 * ScopeRules
 */
export type ScopeRules = {
    /**
     * Version
     */
    version?: number;
    filter?: FilterGroup | null;
};

/**
 * ScopedEncroachmentBreakdownUnit
 *
 * Breakdown of spans and miles by encroachment risk rating.
 */
export type ScopedEncroachmentBreakdownUnit = {
    /**
     * Rating
     *
     * Encroachment risk rating (0=unknown, 1=none, 2=minor, 3=low, 4=medium, 5=high)
     */
    rating: number;
    /**
     * Spancount
     *
     * Number of spans with this encroachment rating
     */
    spanCount: number;
    /**
     * Miles
     *
     * Miles of spans with this encroachment rating
     */
    miles: number;
};

/**
 * SearchResult
 */
export type SearchResult = {
    /**
     * Id
     */
    id: string;
    /**
     * Label
     */
    label: string;
};

/**
 * SearchResults
 */
export type SearchResults = {
    /**
     * Display Name
     */
    display_name: Array<SearchResult>;
    /**
     * Level3 Internal
     */
    level3_internal?: Array<SearchResult> | null;
    /**
     * Point
     */
    point: Array<SearchResult>;
};

/**
 * SearchSummary
 *
 * Empty summary model to maintain API compatibility. This used to be a `total` count of results, but is no longer used.
 */
export type SearchSummary = {
    [key: string]: unknown;
};

/**
 * Span
 */
export type Span = {
    /**
     * Level2
     */
    level2: string;
    /**
     * Level3
     */
    level3: string;
    analysis: GroupAnalysisData | null;
    [key: string]: unknown;
};

/**
 * SpanListReference
 */
export type SpanListReference = {
    /**
     * Listid
     */
    listId: string;
    /**
     * Name
     */
    name: string;
};

/**
 * SpanReference
 */
export type SpanReference = {
    /**
     * Level2
     */
    level2: string;
    /**
     * Level3
     */
    level3: string;
};

/**
 * SpansCountData
 *
 * Data model for spans count response
 */
export type SpansCountData = {
    /**
     * Filtered
     */
    filtered: number;
    /**
     * Total
     */
    total: number;
};

/**
 * SpeciesCondition
 */
export type SpeciesCondition = {
    /**
     * Op
     */
    op: 'IN' | 'NOT_IN';
    /**
     * Values
     */
    values: Array<number>;
    /**
     * Field
     */
    field?: 'species';
};

/**
 * StrikeTreesCountCondition
 */
export type StrikeTreesCountCondition = {
    op: ComparisonOp;
    /**
     * Value
     */
    value: number;
    /**
     * Field
     */
    field?: 'strikeTreesCount';
};

/**
 * TaskStatus
 */
export const TaskStatus = {
    RUNNING: 'running',
    COMPLETED: 'completed',
    FAILED: 'failed',
    CANCELLED: 'cancelled'
} as const;

/**
 * TaskStatus
 */
export type TaskStatus = typeof TaskStatus[keyof typeof TaskStatus];

/**
 * TerminateDraftRunRequest
 */
export type TerminateDraftRunRequest = {
    /**
     * Client Code
     */
    client_code: string;
};

/**
 * TreesSummaryTotal
 */
export type TreesSummaryTotal = {
    type: TreesType;
    /**
     * Totaltrees
     */
    totalTrees: number;
};

/**
 * TreesType
 */
export const TreesType = {
    HAZARD: 'hazard',
    DECLINING: 'declining',
    STRIKE: 'strike'
} as const;

/**
 * TreesType
 */
export type TreesType = typeof TreesType[keyof typeof TreesType];

/**
 * UserDetails
 */
export type UserDetails = {
    /**
     * Email
     */
    email: string;
    /**
     * Intercom Userid
     */
    intercom_userid: string | null;
    /**
     * Intercom User Jwt
     */
    intercom_user_jwt: string | null;
    /**
     * Is Superuser
     */
    is_superuser: boolean;
    /**
     * Can Client Switch
     */
    can_client_switch: boolean;
};

/**
 * VectorLayerSource
 *
 * A table-backed layer the frontend draws from MVT tiles.
 */
export type VectorLayerSource = {
    /**
     * Kind
     */
    kind: 'vector';
    /**
     * Layer Type
     */
    layer_type: string;
    /**
     * Name
     */
    name: string;
};

/**
 * VoltageInKvCondition
 */
export type VoltageInKvCondition = {
    /**
     * Op
     */
    op: 'IN' | 'NOT_IN';
    /**
     * Values
     */
    values: Array<number>;
    /**
     * Field
     */
    field?: 'voltageInKv';
};

/**
 * WILDFIRE_RISK_RATING
 */
export const WildfireRiskRating = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5
} as const;

/**
 * WILDFIRE_RISK_RATING
 */
export type WildfireRiskRating = typeof WildfireRiskRating[keyof typeof WildfireRiskRating];

/**
 * WildfireImpact
 */
export type WildfireImpact = {
    /**
     * Risk In Scope
     */
    risk_in_scope: number;
    /**
     * Relative Risk In Scope Pct
     */
    relative_risk_in_scope_pct: number;
};

/**
 * WildfirePriorityLevelEnum
 */
export const WildfirePriorityLevelEnum = {
    999: 999,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5
} as const;

/**
 * WildfirePriorityLevelEnum
 */
export type WildfirePriorityLevelEnum = typeof WildfirePriorityLevelEnum[keyof typeof WildfirePriorityLevelEnum];

/**
 * WildfirePriorityRatingCondition
 */
export type WildfirePriorityRatingCondition = {
    /**
     * Op
     */
    op: 'IN' | 'NOT_IN';
    /**
     * Values
     */
    values: Array<WildfirePriorityLevelEnum>;
    /**
     * Field
     */
    field?: 'wildfirePriorityRating';
};

/**
 * WildfireRatingCondition
 */
export type WildfireRatingCondition = {
    /**
     * Op
     */
    op: 'IN' | 'NOT_IN';
    /**
     * Values
     */
    values: Array<WildfireRiskRating>;
    /**
     * Field
     */
    field?: 'wildfireRating';
};

/**
 * WorkLogBulkCreateRequest
 */
export type WorkLogBulkCreateRequest = {
    /**
     * Filter Query
     *
     * Base64 encoded GroupAnalysisFilter JSON
     */
    filter_query: string;
    /**
     * Date
     */
    date: string;
    entity_type?: WorkLogEntityType;
    status: WorkLogStatus;
    /**
     * Notes
     */
    notes?: string | null;
    /**
     * List Id
     */
    list_id?: string | null;
};

/**
 * WorkLogBulkUploadResponse
 *
 * Response for CSV bulk upload operations
 */
export type WorkLogBulkUploadResponse = {
    /**
     * Failed
     */
    failed?: Array<string>;
    /**
     * Ignored
     */
    ignored?: Array<string>;
    /**
     * Total Processed
     */
    total_processed?: number;
    /**
     * Succeeded Count
     */
    succeeded_count?: number;
    /**
     * Failed Count
     */
    failed_count?: number;
    /**
     * Ignored Count
     */
    ignored_count?: number;
};

/**
 * WorkLogEncroachmentCounts
 */
export type WorkLogEncroachmentCounts = {
    rating: EncroachmentRiskRating;
    counts: WorkLogStatusCounts;
};

/**
 * WorkLogEntityType
 */
export const WorkLogEntityType = { SPAN: 'span', GROUP: 'group' } as const;

/**
 * WorkLogEntityType
 */
export type WorkLogEntityType = typeof WorkLogEntityType[keyof typeof WorkLogEntityType];

/**
 * WorkLogMetricsResponse
 */
export type WorkLogMetricsResponse = {
    /**
     * Plan Id
     */
    plan_id: string;
    /**
     * Release Id
     */
    release_id: string;
    /**
     * Counts of all non-deleted worklogs linked to the plan
     */
    worklogs: WorkLogStatusCounts;
    /**
     * Counts using each span's latest non-deleted worklog in the plan
     */
    spans: WorkLogSpanMetrics;
};

/**
 * WorkLogNewRequest
 */
export type WorkLogNewRequest = {
    /**
     * Date
     */
    date: string;
    entity_type: WorkLogEntityType;
    /**
     * Entity Id
     */
    entity_id: string;
    status: WorkLogStatus;
    /**
     * Plan Id
     */
    plan_id?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
    /**
     * Source
     */
    source?: string | null;
    source_metadata?: WorkLogSourceMetadataInput | null;
};

/**
 * WorkLogResponse
 */
export type WorkLogResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Entity Id
     */
    entity_id: string;
    entity_type: WorkLogEntityType;
    status: WorkLogStatus;
    /**
     * Client Id
     */
    client_id: number;
    /**
     * Date
     */
    date: string;
    /**
     * Plan Id
     */
    plan_id?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
    /**
     * Source
     */
    source?: string | null;
    source_metadata?: WorkLogSourceMetadataOutput | null;
    /**
     * Program Name
     */
    program_name?: string | null;
    /**
     * Updated At
     */
    updated_at: string;
};

/**
 * WorkLogSourceMetadata
 *
 * Data about the source system that made a work log event.
 */
export type WorkLogSourceMetadataInput = {
    /**
     * Sync Timestamp
     */
    sync_timestamp?: string | null;
    /**
     * Fulcrum Record Id
     */
    fulcrum_record_id?: string | null;
    /**
     * Fulcrum Project Name
     */
    fulcrum_project_name?: string | null;
    /**
     * Fulcrum Version
     */
    fulcrum_version?: number | null;
    /**
     * Source Circuit
     */
    source_circuit?: string | null;
    /**
     * Source Spreadsheet
     */
    source_spreadsheet?: string | null;
    /**
     * Source Spreadsheet Md5
     */
    source_spreadsheet_md5?: string | null;
    /**
     * Program Name
     */
    program_name?: string | null;
};

/**
 * WorkLogSourceMetadata
 *
 * Data about the source system that made a work log event.
 */
export type WorkLogSourceMetadataOutput = {
    /**
     * Sync Timestamp
     */
    sync_timestamp?: string | null;
    /**
     * Fulcrum Record Id
     */
    fulcrum_record_id?: string | null;
    /**
     * Fulcrum Project Name
     */
    fulcrum_project_name?: string | null;
    /**
     * Fulcrum Version
     */
    fulcrum_version?: number | null;
    /**
     * Source Circuit
     */
    source_circuit?: string | null;
    /**
     * Source Spreadsheet
     */
    source_spreadsheet?: string | null;
    /**
     * Source Spreadsheet Md5
     */
    source_spreadsheet_md5?: string | null;
    /**
     * Program Name
     */
    program_name?: string | null;
};

/**
 * WorkLogSpanMetrics
 */
export type WorkLogSpanMetrics = {
    counts: WorkLogStatusCounts;
    /**
     * Encroachment
     */
    encroachment: Array<WorkLogEncroachmentCounts>;
};

/**
 * WorkLogStatus
 */
export const WorkLogStatus = {
    NOT_ADDED: 'not_added',
    COMPLETED: 'completed',
    NO_WORK_NEEDED: 'no_work_needed',
    WORK_NEEDED: 'work_needed'
} as const;

/**
 * WorkLogStatus
 */
export type WorkLogStatus = typeof WorkLogStatus[keyof typeof WorkLogStatus];

/**
 * WorkLogStatusCounts
 */
export type WorkLogStatusCounts = {
    /**
     * Total
     */
    total?: number;
    /**
     * Completed
     */
    completed?: number;
    /**
     * Work Needed
     */
    work_needed?: number;
    /**
     * No Work Needed
     */
    no_work_needed?: number;
    /**
     * Not Added
     */
    not_added?: number;
};

/**
 * WorkLogSummaryResponse
 */
export type WorkLogSummaryResponse = {
    /**
     * Total
     */
    total: number;
};

/**
 * WorkLogUpdateRequest
 */
export type WorkLogUpdateRequest = {
    /**
     * Date
     */
    date?: string | null;
    status?: WorkLogStatus | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * WorkStatusCondition
 */
export type WorkStatusCondition = {
    /**
     * Op
     */
    op: 'IN' | 'NOT_IN';
    /**
     * Values
     */
    values: Array<WorkLogStatus>;
    /**
     * Field
     */
    field?: 'workStatus';
};

/**
 * WorkTypeAnalysis
 */
export type WorkTypeAnalysis = {
    /**
     * Classes
     */
    classes: Array<WorkTypeClassStats>;
    /**
     * Buffer Area M2
     */
    buffer_area_m2: number;
    /**
     * Line Length M
     */
    line_length_m: number;
    /**
     * Uncovered Linear M
     */
    uncovered_linear_m: number;
};

/**
 * WorkTypeClassStats
 */
export type WorkTypeClassStats = {
    /**
     * Worktype Class
     */
    worktype_class: number;
    /**
     * Area M2
     */
    area_m2: number;
    /**
     * Linear M
     */
    linear_m: number;
};

/**
 * Workload
 */
export type Workload = {
    /**
     * Distance Total
     */
    distance_total: number;
    /**
     * Distance In Scope
     */
    distance_in_scope: number;
    unit: RiskUnit;
    /**
     * Breakdown By Encroachment
     */
    breakdown_by_encroachment: Array<NetworkRiskAggregateBreakdownUnit>;
};

/**
 * _Plan
 */
export type Plan = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    scope_filter?: ScopeRules | null;
};

/**
 * _PlanningUnit
 */
export type PlanningUnit = {
    /**
     * Lasttrimdate
     */
    lastTrimDate?: string | null;
    /**
     * Status
     */
    status?: string | null;
    /**
     * Contractor
     */
    contractor?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
    /**
     * Targetstart
     */
    targetStart?: string | null;
    /**
     * Workstarted
     */
    workStarted?: string | null;
    /**
     * Workended
     */
    workEnded?: string | null;
};

/**
 * _PlanningUnitScenario
 */
export type PlanningUnitScenario = {
    /**
     * Nexttrimdate
     */
    nextTrimDate: string | null;
};
